const API_URL = process.env.VUE_APP_API_URL || 'https://api-auth-plf.wee-do-it.net'
const PAYMENT_PROVIDER = process.env.VUE_APP_PAYMENT_PROVIDER || 'sogecommerce'
const TEST_PAYMENT_EMAILS = ['o.weedoit@gmail.com']

export function isTestPaymentAccount() {
  try {
    const email = (JSON.parse(localStorage.getItem('utilisateur') || '{}').email || '').toLowerCase()
    return TEST_PAYMENT_EMAILS.indexOf(email) !== -1
  } catch (e) {
    return false
  }
}

export function getPaymentMinAmount(defaultMin) {
  return isTestPaymentAccount() ? 1 : defaultMin
}

export function getPaymentRequestUrl() {
  return `${API_URL}/api/v1/paymentgetway/${PAYMENT_PROVIDER}/request`
}

export function isCardPaymentSource(source) {
  return source === 'sogecommerce' || source === 'sogenactif' || source === 'Carte Bancaire'
}

export function buildPaymentFormData({ action, amount, utilisateur_id, id, id_coreg }) {
  const formData = new FormData()
  formData.append('action', action)
  formData.append('amount', amount)
  formData.append('utilisateur_id', utilisateur_id)

  if (id !== undefined && id !== null && id !== '') {
    formData.append('id', id)
  }
  if (id_coreg !== undefined && id_coreg !== null && id_coreg !== '') {
    formData.append('id_coreg', id_coreg)
  }

  return formData
}
